import { render, staticRenderFns } from "./EventAnalytics.vue?vue&type=template&id=e4bd1486"
import script from "./EventAnalytics.vue?vue&type=script&setup=true&lang=js"
export * from "./EventAnalytics.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports